<template>
  <div class="">
    <div v-show="planListData.length === 0">
      <p class="mt-5 text-center font-weight-bold">尚未建立行程</p>
    </div>
    <MyPlanList
        :plan-type="planType"
        :plan-list-data="newListData"
        @delete-btn-clicked="deleteBtnClicked(arguments)"
    ></MyPlanList>
  </div>
</template>

<script>
import MyPlanList from "@/views/plan/MyPlanList";

export default {
  name: 'MyPlanTrip',
  data() {
    return {
      
    };
  },
  props: {
    planType: {
      required: true,
    },
    planListData: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
  },
  components: {
    MyPlanList,
  },
  computed: {
    newListData() {
      let newData = []
      if(this.planListData.length) {
        this.planListData.map(function(item) {
          let newObj = {}
          newObj.name = item.name;
          newObj.picUrl = item.picUrl;
          newObj.serial = item._id;
          newObj.path = '/journey/' + item._id;
          newObj.startDate = item.startDate;
          newObj.endDate = item.endDate;
          newData.push(newObj);
        });
      }
      return newData
    },
	},
  watch: {
    
  },
  mounted() {
    
	},
  methods: {
    deleteBtnClicked: function(e) {
      this.$emit('delete-btn-clicked', e[0]);
    },
  }
}
</script>


<style scoped>
  
</style>
